import { Entity } from '@adornis/baseql/decorators.js';
import { KooperationsPartner } from './KooperationsPartner.js';
import { Partner } from './Partner.js';

/**
 * @entity Foundation
 */

@Entity()
export class Foundation extends Partner {
  public static override _class = 'Foundation';

  public override get type() {
    return KooperationsPartner.FOUNDATION;
  }
}
